
export interface Metadata {
  uri: string;
  etag: string;
  type: string;
  id: string;
}

export interface SpResults<T> {
  results: T;
}

export interface SpDataObject<T> {
  results: T[];
  __next?: string;
  __count?: number;
}

export interface SpGetResponse<T> {
  d: SpDataObject<T> & T[];
  value?: SpDataObject<T> & T[];
}

export interface SpGetTopResponse<T> {
  d: Array<T>;
}

export interface SpPostResponse<T> {
  d: T;
}

export interface AttachmentsMetadata {
  content_type: string;
  edit_media: string;
  media_etag: string;
  media_src: string;
  type: string;
  uri: string;
}

export interface AttachmentsResult {
  EntitySet: string;
  ItemId: number;
  Name: string;
  __metadata: AttachmentsMetadata;
}

export interface Attachments {
  results: AttachmentsResult[];
}

export interface Slide {
  Attachments: Attachments;
  Id: number;
  Title: string;
  __metadata: Metadata;
}

export class SpPostHeaders {
  headers = {};

  constructor(
    obj: any,
    remove?: boolean,
    match?: string,
    digest?: string,
  ) {
    if (obj && obj.hasOwnProperty('__metadata') && obj.__metadata !== undefined) {
      this.headers['X-HTTP-Method'] = (remove) ? 'DELETE' : 'MERGE';
      this.headers['If-Match'] = match || '*';
    }
    this.headers['X-RequestDigest'] = digest || 'no_digest';
    this.headers['Content-Type'] = 'application/json;odata=verbose';
    this.headers['Accept'] = 'application/json;odata=verbose';
  }
}

/**
 * @property $filter filters the list
 * @property $select columns to view
 * @property $top number of records to return
 * @property $skip record to start with
 * @property $expand opens the item if deferred
 * @property $orderby orders retured data
 * @property $inlinecount used to get total count of querry, even when $top is used or row limit is reached
 * @property $skiptoken used when server returns a token
 */

export interface SpParams {
  $filter?: string;
  $select?: string;
  $top?: string;
  $skip?: string;
  $expand?: string;
  $orderby?: string;
  $inlinecount?: 'allpages' | 'none';
  $skiptoken?: string;
}

export function spDate(date: Date | string) {
  if (typeof date === 'string') {
    const dateString: string = date.toString();
    const dateNum = parseInt(dateString.replace('/Date(', '').replace(')/', ''), 10);
    date = new Date(dateNum);
    date.setHours(24, 0, 0, 0);
  }
  return date;
}

export function spDateTime(date: Date | string) {
  if (typeof date === 'string') {
    const dateString: string = date.toString();
    const dateNum = parseInt(dateString.replace('/Date(', '').replace(')/', ''), 10);
    date = new Date(dateNum);
  }
  return date;
}
